<template>
  <div class="sample-page">
    <div class="breadcrumb">
      <a-breadcrumb>
        <a-breadcrumb-item>
          <router-link to="/home">首页</router-link>
        </a-breadcrumb-item>
        <a-breadcrumb-item>作业管理</a-breadcrumb-item>
      </a-breadcrumb>
    </div>
    <div class="page-handle">
      <div class="left">
        <a-button type="primary" v-auth="'10501'" @click="appoint()">指派给</a-button>
        <template>
          <a-popover overlayClassName="export-popover" placement="bottomLeft" title="请选择时间区间" v-model="popoverVisible"
            trigger="click">
            <template slot="content">
              <div class="export-content">
                <a-range-picker class="tool-item" @change="onChangePicker" :value="rPrckerVal" />
                <a-button class="export-btn" type="primary" @click="exportFile" v-auth="'10511'">导出
                </a-button>
              </div>
            </template>
            <a-button type="primary" v-auth="'10511'">导出作业目录</a-button>
          </a-popover>
        </template>
        <a-button type="primary" v-auth="'10513'" @click="exportExcelClick()">导出列表</a-button>
        <a-badge v-auth="'10512'" :count="waitNumbersData.num" class="ml5">
          <a-button type="primary" v-auth="'10512'" @click="drawerCollectVisible = true">排队作业</a-button>
        </a-badge>

        <!-- <a-button @click="addJob()"> 执行作业</a-button> -->
        <!-- <a-button v-auth="'10502'" @click="output()"> 输出文件</a-button> -->
        <!-- <a-button v-auth="'10503'" @click='check()'>审核作业</a-button> -->
      </div>
      <div class="right">
        <a-input-search placeholder="请输入作业名称" v-model="jobsName" style="width: 200px" @search="onSearchKey" />
        <a-tooltip placement="bottomRight">
          <template slot="title">
            作业耗时超过规定的时间范围
          </template>
          <a-checkable-tag class="cktag-warnig" v-model="warning" button-style="solid" @change="ckWarning">提醒
          </a-checkable-tag>
        </a-tooltip>
        <a class="filter-btn" @click="drawerVisible = true">筛选
          <a-icon type="filter" />
        </a>
        <a-drawer title="筛选" :width="600" placement="right" :closable="false" :visible="drawerVisible" @close="onClose"
          :body-style="{ paddingBottom: '80px' }">
          <div class="filter-drawer-content">
            <div class="filter-drawer-title">患者组
              <a-icon type="right" />
            </div>
            <a-row>
              <a-col :span="6">
                <a-button :type="!patientGroupId ? 'primary' : 'default'" @click="handleGroupClick({ key: 'default' })">
                  全部
                </a-button>
              </a-col>
              <a-col :span="6" v-for="item in dataGroup" :key="item.id">
                <a-button :type="patientGroupId == item.id ? 'primary' : 'default'"
                  @click="handleGroupClick({ key: item.id })">
                  {{ item.groupName }} ({{ item.numbers }})
                </a-button>
              </a-col>
            </a-row>
            <div class="filter-drawer-title">审核状态
              <a-icon type="right" />
            </div>
            <a-row>
              <a-col :span="6">
                <a-button :type="!searchKey1 ? 'primary' : 'default'" @click="handleVerifyClick({ key: 'default' })">
                  全部
                </a-button>
              </a-col>
              <a-col :span="6" v-for="item in searchMapKey1" :key="item.keyId" v-if="item.keyId != ''">
                <a-button :type="searchKey1 == item.keyId ? 'primary' : 'default'"
                  @click="handleVerifyClick({ key: item.keyId })">
                  {{ item.value }} ({{ item.numbers }})
                </a-button>
              </a-col>
            </a-row>
            <div class="filter-drawer-title">作业状态
              <a-icon type="right" />
            </div>
            <a-row>
              <a-col :span="8">
                <a-button :type="!searchKey2 ? 'primary' : 'default'" @click="handleJobClick({ key: 'default' })">
                  全部
                </a-button>
              </a-col>
              <a-col :span="8" v-for="item in statSatausData" :key="item.keyId" v-if="item.keyId != 'allnum'">
                <a-button :type="searchKey2 == item.keyId ? 'primary' : 'default'"
                  @click="handleJobClick({ key: item.keyId })">
                  {{ item.value }} ({{ item.numbers}})
                  <!-- <template v-if="item.keyId === '-1'">
                    ({{ statSatausData["notnum"] }})
                  </template>
                  <template v-else>
                    ({{ statSatausData[item.operateStatus] }})
                  </template> -->
                </a-button>
              </a-col>
            </a-row>
          </div>
          <div :style="{
            position: 'absolute',
            bottom: 0,
            width: '100%',
            borderTop: '1px solid #e8e8e8',
            padding: '10px 16px',
            textAlign: 'right',
            left: 0,
            background: '#fff',
            borderRadius: '0 0 4px 4px',
          }">
            <a-button style="marginRight: 8px" @click="resetDrawer">
              重置
            </a-button>
            <a-button type="primary" @click="okDrawer">
              确定
            </a-button>
          </div>
        </a-drawer>
      </div>
    </div>
    <div class="page-content">
      <a-table class="hospital-table" v-if='data' :pagination="false" :loading="loading" :rowSelection="rowSelection"
        :rowKey="record => record.id" :columns="columns" :dataSource="data" size="middle">
        <router-link v-auth="'10505'" v-if="record.jobsStatus" slot="jobsName" slot-scope="text,record"
          :to="{ path: 'job/details', query: { id: record.id } }">{{ text }}
        </router-link>
        <div v-auth="'10505'" v-else slot="jobsName" slot-scope="text,record" @click="goToDetails(record)" class="link">
          {{ text }}
        </div>
        <template slot="warningStatus" slot-scope="text,record">
          <a-tag v-if="record.warningHours !== 0" :color="record.warningStatus === '临近' ? 'orange' : '#f50'">
            {{ record.warningStatus }}
          </a-tag>
          <a-tag v-else color="#87d068">正常</a-tag>
        </template>
        <template slot-scope='text,record' slot='op'>
          <div class="table-tr-handle">
            <span v-auth="'10504'"
              v-if='record.jobsStatus == null || record.jobsStatus == "failed" || record.jobsStatus == "psudone" || record.jobsStatus == "cancel"'
              class="handle-btn" @click='addJob($event, record)'>提交作业
            </span>
            <span v-auth="'10504'"
              v-if='record.jobsStatus == null || record.jobsStatus == "failed" || record.jobsStatus == "psudone" || record.jobsStatus == "cancel"'
              class="handle-line">|</span>
            <span v-auth="'10510'" class="handle-btn" @click='delJobCk($event, record)'>删除
            </span>
          </div>
        </template>
      </a-table>
      <div class="pagination">
        <a-pagination @change="pageChange" :pageSize.sync="pageSize" v-model="page" size="small" :total="resData.total" />
      </div>
    </div>
    <a-drawer title="作业排队列表" :width="600" placement="right" :closable="false" :visible="drawerCollectVisible"
      @close="onClose" :body-style="{ paddingBottom: '80px' }">
      <div class="filter-drawer-content">
        <div class="drawer-page-content">
          <a-table class="hospital-table" :pagination="false" :columns="columnsWait" :dataSource="waitNumbersData.items"
            :rowKey="(record, index) => { return index }" size="middle"></a-table>
        </div>
      </div>
    </a-drawer>
    <page-model @close="closeModel" :visible="visible">
      <appoint v-if='visible && isAppoint == 1' @close='closeModel' @update='update' :selectedData='selectedData'>
      </appoint>
      <check-job v-if='visible && isAppoint == 3' @close='closeModel'></check-job>
    </page-model>

    <!-- 作业小弹窗 -->
    <!-- 二次弹窗 -->
    <h-confirm :visible="confirmVisible" @close="closeConfirm" @ok="okClick" :loadding.sync="confirmLoadding"
      :title="currentConfirmData.title" :content="currentConfirmData.content" :desc="currentConfirmData.desc">
    </h-confirm>

  </div>
</template>

<script>
import Appoint from './appoint'
import CheckJob from './check'
import auth from "../../directives/auth-utils";

const columnsWait = [
  {
    title: "序号",
    customRender: (text, record, index) => `${index + 1}`,
    width: '15%'
  },
  {
    title: "协作组条码",
    dataIndex: "hosBarCode",
    customRender: (text, record, index) => {
      if (!record.hosBarCode) {
        return '-'
      } else {
        return record.hosBarCode
      }
    }
  },
  {
    title: "检测项目",
    dataIndex: "applyItemValue",
    customRender: (text, record, index) => {
      if (!record.applyItemValue) {
        return '-'
      } else {
        return record.applyItemValue
      }
    }
  },
  {
    title: "创建时间",
    dataIndex: "createTime",
    customRender: (text, record, index) => {
      if (!record.createTime) {
        return '-'
      } else {
        return record.createTime
      }
    },
  }
];
const columns = [
  {
    title: "序号",
    customRender: (text, record, index) => `${index + 1}`
  },
  {
    title: "提醒",
    dataIndex: "warningStatus",
    scopedSlots: { customRender: "warningStatus" }
  },
  {
    title: "协作组条码",
    dataIndex: "hosBarCode",
    customRender: (text, record, index) => {
      if (!record.hosBarCode) {
        return '-'
      } else {
        return record.hosBarCode
      }
    }
  },
  {
    title: "作业名称",
    scopedSlots: { customRender: "jobsName" },
    dataIndex: "jobsName"
  },
  {
    title: "流程名称",
    dataIndex: "flowName",
    customRender: (text, record, index) => {
      if (!record.flowName) {
        return '-'
      } else {
        return record.flowName
      }
    }
  },
  {
    title: "分析人员",
    dataIndex: "analyzeName",
    customRender: (text, record, index) => {
      if (!record.analyzeName) {
        return '-'
      } else {
        return record.analyzeName
      }
    }
  },
  {
    title: "审核状态",
    dataIndex: "verifyStatusName",
    customRender: (text, record, index) => {
      if (!record.verifyStatusName) {
        return '-'
      } else {
        return record.verifyStatusName
      }
    }
  },
  {
    title: "耗时",
    dataIndex: "takeUpTime",
    customRender: (text, record, index) => {
      if (record.startTime) {
        let startTime = new Date(record.startTime).getTime();
        let endTime;
        if (record.endTime) {
          endTime = new Date(record.endTime).getTime();
        } else {
          endTime = new Date().getTime();
        }

        //获取时间差
        var timediff = Math.round((endTime - startTime) / 1000);
        //获取还剩多少天
        // var day = parseInt(timediff / 3600 / 24);
        //获取还剩多少小时
        var hour = parseInt((timediff / 3600));
        //获取还剩多少分钟
        var minute = parseInt((timediff / 60) % 60);
        //获取还剩多少秒
        var second = timediff % 60;
        if (hour < 10) {
          hour = "0" + hour
        } else {
          hour = hour
        }
        if (minute < 10) {
          minute = "0" + minute
        } else {
          minute = minute
        }
        if (second < 10) {
          second = "0" + second
        } else {
          second = second
        }
        return hour + ":" + minute + ":" + second;
        // day + "天" + hour + "小时" + minute + "分钟" + second + "秒";
      } else {
        return '-'
      }
    }
  },
  {
    title: "分组",
    dataIndex: "groupName",
    customRender: (text, record, index) => {
      if (!record.groupName) {
        return '-'
      } else {
        return record.groupName
      }
    }
  },
  {
    title: "作业状态",
    dataIndex: "jobsStatusName",
    customRender: (text, record, index) => {
      if (!record.jobsStatusName) {
        return '-'
      } else {
        return record.jobsStatusName
      }
    }
  },
  {
    title: "开始时间",
    dataIndex: "cloudCreateTime",
    customRender: (text, record, index) => {
      if (!record.cloudCreateTime) {
        return '-'
      } else {
        return record.cloudCreateTime
      }
    },
    width: '7%'
  },
  {
    title: "结束时间",
    // scopedSlots: {customRender: "finishTime"},
    dataIndex: "endTime",
    customRender: (text, record, index) => {
      if (!record.endTime) {
        return '-'
      } else {
        return record.endTime
      }
    },
    width: '7%'
  },
  {
    title: "操作",
    scopedSlots: { customRender: "op" },
    // dataIndex: "finishTime"
  }
];
let mockData = {
  hosBarCode: "CCCGxxxyyyyyy",
  barCode: "",
  sampleId: "香港中文大学威尔斯亲王医院",
  sampleAmount: "张三",
  sampleType: "是",
  address: "男",
  operateType: "12",
  operateDate: "800006169",
  userName: "2019-02-15",
  msgFrom: "aa"

};
export default {
  data() {
    return {
      visible: false,
      loading: false,
      confirmVisible: false,
      confirmLoadding: false,
      drawerCollectVisible: false,
      currentConfirmData: {},
      rPrckerVal: null,
      dowmSampleOpt: {
        startTime: null,
        endTime: null
      },
      popoverVisible: false,
      resetJob: {
        title: "重启作业",
        content: "您确认要重启“作业名称”作业吗？",
        desc: "",
        operateType: "confirm-reset"
      },
      delJob: {
        title: "删除作业",
        content: "您确认要删除作业吗？",
        desc: "",
        operateType: "confirm-del"
      },
      stopJob: {
        title: "暂停作业",
        content: "您确认要暂停“作业名称”作业吗？",
        desc: "",
        operateType: "confirm-reset"
      },
      cancelJob: {
        title: "取消作业",
        content: "您确认要取消“作业名称”作业吗？",
        desc: "",
        operateType: "confirm-canel"
      },
      warning: false,
      isAppoint: 0,
      data: [],
      resData: [],
      columns,
      columnsWait,
      jobsName: '',
      page: 1,
      pageSize: 10,
      dataGroup: [],
      groupTitle: '选择组',
      patientGroupId: '',
      searchKey1: '',
      searchMapKey1: [],
      searchLableKey1: '审核状态',
      searchKey2: '',
      searchMapKey2: [
        // {operateStatus: "submit", operateStatusRemark: "已提交"},
        { operateStatus: "running", operateStatusRemark: "运行中" },
        // {operateStatus: "pause", operateStatusRemark: "作业暂停"},
        { operateStatus: "cancel", operateStatusRemark: "作业取消" },
        { operateStatus: "failed", operateStatusRemark: "作业失败" },
        { operateStatus: "psudone", operateStatusRemark: "作业部分失败" },
        { operateStatus: "done", operateStatusRemark: "作业已完成" },
        { operateStatus: "-1", operateStatusRemark: "-" },
      ],
      searchLableKey2: '作业状态',
      selectedData: [],
      selectedRowKeys: [],
      selectRows: {},
      drawerVisible: false,
      waitNumbersData: {},
      statSatausData: [],

    };
  },
  components: {
    Appoint,
    CheckJob
  },
  computed: {
    rowSelection() {
      const { selectedRowKeys } = this;
      return {
        selectedRowKeys,
        onChange: (selectedRowKeys, selectedRows) => {
          this.selectedRowKeys = selectedRowKeys
          this.selectedData = selectedRows
        },
        getCheckboxProps: record => ({
          props: {
            disabled: record.name === "Disabled User", // Column configuration not to be checked
            name: record.name
          }
        })
      };
    }
  },
  watch: {
    drawerVisible(val, oldVal) {
      if (val) {
        this.getStatStatus();
      }
    }
  },
  mounted() {
    this.currentConfirmData = this.resetJob;
    this.getStorage();
    this.getGroupList();
    this.getVerifyStatusStat();
    this.getWaitNumbers();
  },
  methods: {
    getWaitNumbers() {
      this.$get("patientitem/patientItem/waitNumbers").then(res => {
        this.waitNumbersData = res.data.data;
      });
    },
    getStatStatus() {
      this.$get("jobsmanage/jobs/getStatStatus", { module: 3 }).then(res => {
        this.statSatausData = res.data.data;
      });
    },
    update() {
      this.getData();
    },
    // 首次加载时获取缓存的列表筛选值
    getStorage() {
      if (localStorage.getItem('JOB_FILTER')) {
        const params = JSON.parse(localStorage.getItem('JOB_FILTER'));
        this.pageSize = params.pageSize;
        this.page = params.pageNum;
        this.jobsName = params.jobsName;
        this.patientGroupId = params.patientGroupId;
        this.searchKey1 = params.verifyStatus;
        this.searchKey2 = params.jobsStatus;
        this.warning = params.warning;
        if (this.searchKey1) {
          this.handleVerifyClick({ key: this.searchKey1 }, true);
        }
        if (this.searchKey2) {
          this.handleJobClick({ key: this.searchKey2 }, true);
        }
      }
      this.getData();
    },
    onClose() {
      this.drawerVisible = false;
      this.drawerCollectVisible = false;
    },
    resetDrawer() {
      this.page = 1;
      this.patientGroupId = '';
      this.searchKey1 = '';
      this.searchKey2 = '';
      this.getData();
    },
    okDrawer() {
      this.page = 1;
      this.drawerVisible = false;
      this.getData();
    },
    addJob($event, record) {
      $event.stopPropagation();
      if (record.analyzeName) {
        let queryData = {
          id: record.id,
          bid: record.bid
        }
        this.$router.push({ path: '/job/add', query: queryData })
      } else {
        this.$message.warning('请先指派分析人员');
      }

      // this.$router.push('/job/add')
    },
    delJobCk($event, record) {
      this.confirmVisible = true;
      this.selectRows = record;
      this.currentConfirmData = this.delJob;
    },
    goToDetails(record) {
      if (auth.auth("10505")) {
        if (record.jobsStatus) {
          this.$router.push({
            path: "/job/details",
            query: {
              id: record.id
            }
          });
        } else {
          this.$message.error('请先执行作业')
        }
      }
    },
    closeConfirm() {
      this.confirmVisible = false;
      // this.getData();
    },
    okClick() {
      if (this.currentConfirmData.operateType == "confirm-del") {
        this.handleDiagnosis(
          this.selectRows,
          this.currentConfirmData.operateType,
          () => {
            this.confirmVisible = false;
            this.getData();
          }
        );
      }
    },
    handleDiagnosis(item, type, callback) {
      if (type == "confirm-del") {
        this.$get('/jobsmanage/jobs/delete', { jobId: item.id }).then(
          res => {
            this.$message.success("删除成功");
            if (callback) {
              callback();
            }
          },
          () => {
            this.confirmLoadding = false;
            this.$message.error("删除失败");
          }
        );
      }
    },
    closeModel() {
      this.visible = false;
      this.isAppoint = 0
    },
    appoint() {
      if (this.selectedData.length > 0) {
        let flag = true
        for (let val of this.selectedData) {
          if (val.verifyId) {
            flag = true;
            break;
          } else {
            flag = false
          }
        }
        if (!flag) {
          this.isAppoint = 1;
          this.visible = true
        } else {

          this.$message.error('已经指派的作业不要重复指派')

        }

      } else {
        this.$message.error('请至少选择一个作业')
      }

    },
    exportExcelClick() {
      let params = {
        jobsStatus: this.searchKey2,
        verifyStatus: this.searchKey1,
        jobsName: this.jobsName,
        patientGroupId: this.patientGroupId,
        warning: this.warning,
      };
      params = this.deleteEmpty(params);
      if (params.warning) {
        params.warning = 1;
      }
      this.$export('/jobsmanage/jobs/down', params, '作业管理列表');
    },
    check() {
      this.isAppoint = 3;
      this.visible = true
    },
    getGroupList() {
      this.dataGroup = [];
      this.$get("patientgroup", { module: 3 }).then(res => {
        this.dataGroup = res.data.data;
        if (this.patientGroupId) {
          this.handleGroupClick({ key: this.patientGroupId }, true);
        }
      });
    },
    getVerifyStatusStat() {
      this.$get("report/report/getVerifyStatusStat", { module: 3 }).then((res) => {
        this.searchMapKey1 = res.data.data;
      });
    },
    // 删除params里空值
    deleteEmpty(params) {
      Object.keys(params).forEach((key) => {
        const value = params[key];
        if (!value || Array.isArray(value) && value.length == 0) {
          delete params[key]
        }
      })
      return params;
    },
    getData() {
      this.loading = true;
      let params = {
        pageSize: this.pageSize,
        pageNum: this.page,
        jobsStatus: this.searchKey2,
        verifyStatus: this.searchKey1,
        jobsName: this.jobsName,
        patientGroupId: this.patientGroupId,
        warning: this.warning,
      };
      params = this.deleteEmpty(params);
      localStorage.setItem('JOB_FILTER', JSON.stringify(params));
      if (params.warning) {
        params.warning = 1;
      }
      this.$get("jobsmanage/jobs/jobsListPage", params).then(res => {
        this.resData = res.data.data;
        this.data = this.resData.rows;
        this.selectedRowKeys = []
        this.loading = false;
      });
    },
    onSearchKey(value) {
      this.jobsName = value;
      this.page = 1;
      this.getData();
    },
    pageChange(page, pagesize) {
      this.page = page;
      this.pageSize = pagesize;
      this.getData();
    },
    handleVerifyClick({ key }, bol) {
      if (key == 'default') {
        this.searchKey1 = '';
        this.searchLableKey1 = '审核状态';
      } else {
        let dictValue = '';
        this.searchKey1 = key;
        this.searchMapKey1.forEach(function (item, i) {
          if (item.dictKey == key) {
            dictValue = item.dictValue;
            return;
          }
        })
        this.searchLableKey1 = dictValue;
      }
    },
    ckWarning(e) {
      this.page = 1;
      this.getData();
    },
    handleJobClick({ key }, bol) {
      if (key == 'default') {
        this.searchKey2 = '';
        this.searchLableKey2 = '作业状态';
      } else {
        let dictValue = '';
        this.searchKey2 = key;
        this.searchMapKey2.forEach(function (item, i) {
          if (item.operateStatus == key) {
            dictValue = item.operateStatusRemark;
            return;
          }
        })
        this.searchLableKey2 = dictValue;
      }
    },
    // 选择组 查询
    handleGroupClick(e, bol) {
      if (e.key == 'default') {
        this.groupTitle = '请选择';
        this.patientGroupId = '';
      } else {
        this.dataGroup.forEach((item, index) => {
          if (item.id == e.key) {
            this.groupTitle = item.groupName;
            return;
          }
        });
        this.patientGroupId = e.key;
      }
    },
    getDirt(dictType) {
      return new Promise((resolve, reject) => {
        this.$get("info/commonDict", {
          dictType: dictType
        }).then(
          res => {
            resolve(res.data.data);
          },
          err => {
            reject(err);
          }
        );
      });
    },
    exportFile() {
      let url = "/jobsmanage/jobs/dowmSample";
      let opt = this.dowmSampleOpt;
      let dFilename = 'sample_' + new Date().getTime() + '.tag';
      this.$download(url, opt, dFilename);
    },
    //请选择时间区间 导出
    onChangePicker(val, dateString) {
      if (dateString.length > 0) {
        this.rPrckerVal = val;
        this.dowmSampleOpt = {
          startTime: dateString[0],
          endTime: dateString[1],
        }
      }
    },
    getBaseInfo(dictType) {
      return new Promise((resolve, reject) => {
        this.$post("base/baseInfo/findOperateByBigClassify", dictType, {
          "Content-Type": "application/json"
        }).then(
          res => {
            resolve(res.data.data);
          },
          err => {
            reject(err);
          }
        );
      });
    },
  }
};
</script>

<style lang="scss" scoped>
.export-popover {
  .export-content {
    padding: 0px 10px;

    .tool-item {
      width: 260px;
      font-size: 12px;
    }

    .export-btn {
      margin-left: 15px;
      font-size: 12px;
    }
  }
}

.sample-page {
  width: 100%;
  min-width: 1200px;

  .ml5 {
    margin-left: 5px;
  }

  .hs-dropdown-width110 {
    display: inline-block;
    line-height: 20px;
    width: 110px;
  }

  .page-handle {
    height: 60px;
    background: #f8fbfb;
    padding: 0 40px;
    line-height: 60px;
    border-top: 1px solid rgba(240, 242, 245, 1);
    border-bottom: 1px solid rgba(240, 242, 245, 1);

    .right {
      float: right;
      height: 60px;

      .hospital-dropdown-link {
        margin-left: 25px;
      }

      .hospital-dropdown-link {
        color: #3e7ff7;
        font-size: 12px;
      }
    }

    .left {
      height: 60px;
      float: left;

      .ant-btn+.ant-btn {
        margin-left: 5px;
      }
    }
  }

  .page-content {
    padding: 20px 40px;
    background: #fff;

    .table-tr-handle {
      font-size: 12px;
      font-family: PingFang SC;
      font-weight: 400;
      color: rgba(66, 142, 247, 1);

      .handle-btn {
        cursor: pointer;
      }

      .handle-line {
        margin: 0 10px;
      }

      .handle-more {
        margin-left: 25px;

        /deep/ .iconfont {
          font-size: 18px;
        }
      }
    }

    .pagination {
      margin: 20px 0;
      text-align: right;
    }
  }
}
</style>